export function setOpenDrawer(openDrawer) {
	return {
		type: 'OPEN_DRAWER',
		openDrawer,
	};
}
